import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import React from "react";

// ── SHIMMER ──
const Shimmer = ({
  width = "100%",
  height = "20px",
  borderRadius = "8px",
  sx = {},
}) => (
  <Box
    sx={{
      width,
      height,
      borderRadius,
      background:
        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
      backgroundSize: "200% 100%",
      animation: "shimmer 1.4s infinite",
      flexShrink: 0,
      "@keyframes shimmer": {
        "0%": { backgroundPosition: "200% 0" },
        "100%": { backgroundPosition: "-200% 0" },
      },
      ...sx,
    }}
  />
);

// ── SINGLE CARD — named export so other files can import it ──
export const OverviewCard = ({ color, count, text, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      flex: 1,
      minWidth: 0,
      backgroundColor: alpha(color, 0.05),
      border: `1px solid ${alpha(color, 0.3)}`,
      borderLeft: `4px solid ${color}`,
      height: "100%",
      borderRadius: "16px",
      pl: 2.5,
      py: 1.5,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      cursor: onClick ? "pointer" : "default",
      transition: "box-shadow 0.2s ease",
      "&:hover": onClick
        ? { boxShadow: `0 4px 16px ${alpha(color, 0.18)}` }
        : {},
    }}
  >
    <Typography sx={{ fontSize: "24px", fontWeight: 500, color: "#000" }}>
      {count}
    </Typography>
    <Typography sx={{ fontSize: "16px", color: "#444", fontWeight: "300" }}>
      {text}
    </Typography>
  </Box>
);

// ── OVERVIEW CARDS SECTION — default export ──
const OverviewCards = ({ overView, loading }) => {
  return (
    <Box
      sx={{
        px: "20px",
        py: "20px",
        background: "#FFF",
        borderRadius: 2.5,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "8px",
        boxSizing: "border-box",
      }}
    >
      <Typography sx={{ fontSize: "18px", fontWeight: "600", p: 0, m: 0 }}>
        My Overview
      </Typography>

      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
        {loading
          ? [...Array(5)].map((_, i) => (
              <Box
                key={i}
                sx={{
                  flex: 1,
                  borderRadius: "16px",
                  border: "1px solid #f0f0f0",
                  borderLeft: "4px solid #e8e8e8",
                  pl: 2.5,
                  py: 1.5,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Shimmer width="50%" height="32px" borderRadius="6px" />
                <Shimmer width="80%" height="18px" borderRadius="6px" />
              </Box>
            ))
          : overView.map((card, index) => (
              <OverviewCard
                key={index}
                color={card.color}
                count={card.count}
                text={card.text}
              />
            ))}
      </Box>
    </Box>
  );
};

export default OverviewCards;
